import { Modal } from '@chegg-ui/modal';
import React from 'react';
import { ElementType, LinkText, SpecType, SubType } from '../../../utils/RioUtils/interfaces';
import { sendRioEvent } from '../../../utils/RioUtils/rioHelper';
import { isContentAvailable, parseTncPromptText, getTncPromptText } from '../helper';
import { useTnCBehavior } from '../hooksHelper';
import { ContentDisplayMode } from '../interfaces';
import { BillingHeading, TermsAndConditionsContainer, TncModalContent } from '../styled';
import { DataTestAttributes } from '../constants';
export var TncModal = function TncModal(_ref) {
  var _ref$isCouponApplied = _ref.isCouponApplied,
    isCouponApplied = _ref$isCouponApplied === void 0 ? false : _ref$isCouponApplied,
    onRioEventFired = _ref.onRioEventFired,
    content = _ref.content,
    onError = _ref.onError,
    namespace = _ref.namespace,
    headingLevel = _ref.headingLevel,
    price = _ref.price,
    priceWithDiscount = _ref.priceWithDiscount,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    isOpenCallback = _ref.isOpenCallback,
    formattedTermsContent = _ref.formattedTermsContent,
    billingCycleContentKey = _ref.billingCycleContentKey,
    _ref$ctaLabel = _ref.ctaLabel,
    ctaLabel = _ref$ctaLabel === void 0 ? 'Join now' : _ref$ctaLabel,
    dcoExperimentVariationEnabled = _ref.dcoExperimentVariationEnabled;
  if (!content) return null;
  var verifyContent = isContentAvailable(content, ContentDisplayMode.MODAL, onError);
  if (!verifyContent) return null;
  var _useTnCBehavior = useTnCBehavior({
      content: content,
      isOpen: isOpen,
      onError: onError,
      contentDisplayMode: ContentDisplayMode.MODAL,
      isOpenCallback: isOpenCallback,
      onRioEventFired: onRioEventFired,
      namespace: namespace
    }),
    termsTextTitle = _useTnCBehavior.termsTextTitle,
    setTncOpen = _useTnCBehavior.setTncOpen,
    cheggTermsOfUseLink = _useTnCBehavior.cheggTermsOfUseLink,
    privacyPolicyLink = _useTnCBehavior.privacyPolicyLink,
    cheggTermsOfUseText = _useTnCBehavior.cheggTermsOfUseText,
    privacyPolicyText = _useTnCBehavior.privacyPolicyText,
    tncPromptText = _useTnCBehavior.tncPromptText,
    tncPromptTextWithCoupon = _useTnCBehavior.tncPromptTextWithCoupon,
    termsTitle = _useTnCBehavior.termsTitle,
    tncLinkRef = _useTnCBehavior.tncLinkRef,
    tncOpen = _useTnCBehavior.tncOpen,
    billingHeading = _useTnCBehavior.billingHeading,
    tncPromptTextWithDuration = _useTnCBehavior.tncPromptTextWithDuration,
    planDuration = _useTnCBehavior.planDuration,
    frequency = _useTnCBehavior.frequency;
  var linkClickAction = function linkClickAction(event, elementText, openModal) {
    openModal && event.preventDefault();
    sendRioEvent({
      info: LinkText.TERMS_AND_PRIVACY_POLICY,
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.LINK,
      callback: onRioEventFired,
      namespace: namespace,
      elementText: elementText
    });
    openModal && setTncOpen(true);
  };
  var tncLinkInfo = {
    tncPromptText: getTncPromptText({
      isCouponApplied: isCouponApplied,
      billingCycleContentKey: billingCycleContentKey,
      tncPromptTextWithCoupon: tncPromptTextWithCoupon,
      tncPromptText: tncPromptText,
      tncPromptTextWithDuration: tncPromptTextWithDuration
    }),
    termsTitle: termsTitle,
    linkClickAction: linkClickAction,
    tncLinkRef: tncLinkRef,
    upiTou: content.upiTou || '',
    upiVendorPrivacyPolicyUrl: content.upiVendorPrivacyPolicyUrl,
    upiVendorPrivacyPolicyText: content.upiVendorPrivacyPolicyText
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TermsAndConditionsContainer, {
    "data-test": DataTestAttributes.TERMS_AND_CONDITIONS_MODAL
  }, billingHeading && !tncOpen && /*#__PURE__*/React.createElement(BillingHeading, {
    "data-test": DataTestAttributes.BILLING_HEADING,
    "aria-level": headingLevel,
    dcoExperimentVariationEnabled: !!dcoExperimentVariationEnabled
  }, billingHeading), !tncOpen && parseTncPromptText({
    tncLinkInfo: tncLinkInfo,
    cheggTermsOfUseLink: cheggTermsOfUseLink,
    privacyPolicyLink: privacyPolicyLink,
    price: price,
    priceWithDiscount: priceWithDiscount,
    cheggTermsOfUseText: cheggTermsOfUseText,
    privacyPolicyText: privacyPolicyText,
    ctaLabel: ctaLabel,
    planDuration: planDuration === null || planDuration === void 0 ? void 0 : planDuration[billingCycleContentKey],
    frequency: frequency === null || frequency === void 0 ? void 0 : frequency[billingCycleContentKey]
  }), tncOpen && /*#__PURE__*/React.createElement(Modal, {
    isOpen: true,
    id: 'tncModal',
    "data-test": 'TNC_MODAL',
    title: termsTextTitle,
    onClose: function onClose() {
      return setTncOpen(false);
    },
    shouldCloseOnClickOutside: true,
    hideBackgroundOverlay: false,
    hideCloseButton: false,
    renderFullScreenOnMobile: true,
    renderFullScreenWithMarginOnMobile: false
  }, /*#__PURE__*/React.createElement(TncModalContent, {
    dangerouslySetInnerHTML: formattedTermsContent
  }))));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/TermsAndConditions/variants/TncModal.js
// module id = 4040
// module chunks = 11